import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Navbar.css';

const CustomNavbar = ({ signOut, user }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar d-none d-md-block" style={{ backgroundColor: 'var(--neutral-dark)', color: 'var(--white)', padding: '0.25rem 0', fontSize: '0.875rem' }}>
       
          <div className="d-flex justify-content-between align-items-center">
            <div>
              📞 +65 98592974 | ✉️ startidbits@gmail.com
            </div>
            <div className="text-center">
              <div style={{ fontWeight: '700', color: 'white', fontSize: '14px' }}>Enjoy FREE Shipping on Orders Over S$200! For purchases under S$200, conveniently pick up in-store.</div>
              <div style={{ fontSize: '12px', color: '#ccc' }}>Shop Now • Shipping within 3 days</div>
            </div>
          </div>
       
      </div>
      
      {/* Main Navigation */}
      <Navbar 
        expand="lg" 
        className="animated-nav-background"
        style={{ 
          boxShadow: '0 2px 10px rgba(232, 12, 129, 0.2)',
          padding: isHomePage ? '0.25rem 0' : '1rem 0',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(232, 12, 129, 0.1)'
        }}
        variant="dark"
      >
        <Container style={{ paddingTop: 0, paddingBottom: 0 }}>
          <Navbar.Brand href="/">
            <img 
              src={logo} 
              alt="Star Tidbits" 
              style={{ 
                height: isHomePage ? '200px' : '60px', 
                width: 'auto',
                maxWidth: '100%'
              }}
              className="navbar-logo"
            />
          </Navbar.Brand>
          
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <LinkContainer to="/">
                <Nav.Link 
                  style={{ 
                    color: 'white',
                    fontFamily: '"Geist", "Geist Placeholder", "Inter", sans-serif',
                    fontWeight: '500',
                    fontSize: '0.95rem',
                    letterSpacing: '0.025em'
                  }}
                  onMouseEnter={(e) => e.target.style.fontWeight = '700'}
                  onMouseLeave={(e) => e.target.style.fontWeight = '500'}
                >
                  Home
                </Nav.Link>
              </LinkContainer>
              
              <LinkContainer to="/products">
                <Nav.Link 
                  style={{ 
                    color: 'white',
                    fontFamily: '"Geist", "Geist Placeholder", "Inter", sans-serif',
                    fontWeight: '500',
                    fontSize: '0.95rem',
                    letterSpacing: '0.025em'
                  }}
                  onMouseEnter={(e) => e.target.style.fontWeight = '700'}
                  onMouseLeave={(e) => e.target.style.fontWeight = '500'}
                >
                  Products
                </Nav.Link>
              </LinkContainer>
              
              <LinkContainer to="/services">
                <Nav.Link 
                  style={{ 
                    color: 'white',
                    fontFamily: '"Geist", "Geist Placeholder", "Inter", sans-serif',
                    fontWeight: '500',
                    fontSize: '0.95rem',
                    letterSpacing: '0.025em'
                  }}
                  onMouseEnter={(e) => e.target.style.fontWeight = '700'}
                  onMouseLeave={(e) => e.target.style.fontWeight = '500'}
                >
                  Services
                </Nav.Link>
              </LinkContainer>
              
              <LinkContainer to="/about">
                <Nav.Link 
                  style={{ 
                    color: 'white',
                    fontFamily: '"Geist", "Geist Placeholder", "Inter", sans-serif',
                    fontWeight: '500',
                    fontSize: '0.95rem',
                    letterSpacing: '0.025em'
                  }}
                  onMouseEnter={(e) => e.target.style.fontWeight = '700'}
                  onMouseLeave={(e) => e.target.style.fontWeight = '500'}
                >
                  About Us
                </Nav.Link>
              </LinkContainer>
              
              <LinkContainer to="/contact">
                <Nav.Link 
                  style={{ 
                    color: 'white',
                    fontFamily: '"Geist", "Geist Placeholder", "Inter", sans-serif',
                    fontWeight: '500',
                    fontSize: '0.95rem',
                    letterSpacing: '0.025em'
                  }}
                  onMouseEnter={(e) => e.target.style.fontWeight = '700'}
                  onMouseLeave={(e) => e.target.style.fontWeight = '500'}
                >
                  Contact
                </Nav.Link>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default CustomNavbar;